import styled from 'styled-components';

export const FormWrap = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '100%')};
  width: 100%;

  @media only screen and (max-width: 900px) {
    max-width: 100%;
    flex: 1 0 auto;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.twoColumns ? `1fr 1fr` : `1fr`)};
  grid-gap: 32px;
  width: 100%;
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '100%')};
`;
